import { NextCustomImage } from 'components/Image';
import Heading from 'styles/typography/Heading';
import * as S from './AccoladesHeaderStyles';

export interface AccoladesHeaderProps {
  title: string;
  hasTOC: boolean;
  image: {
    altText: string;
    mediaItemUrl: string;
  };
}

const AccoladesHeader = ({ title, image, hasTOC }: AccoladesHeaderProps) => (
  <S.Wrapper
    className='accolades-header'
    $hasTOC={hasTOC}
  >
    <div>
      <Heading
        as='h1'
        $fontFamily='graphikCond'
        $size={{ default: 'level1', lgMin: 'xxlarge', mdMin: 'xlarge' }}
      >
        {title}
      </Heading>
      <NextCustomImage
        src={image.mediaItemUrl}
        alt={image.altText}
        width={450}
        height={300}
      />
    </div>
  </S.Wrapper>
);

export default AccoladesHeader;
